import { Action, createReducer, on } from '@ngrx/store';

import {
  deleteAlertSuccessAction,
  closeDeleteToastAction,
  createAlertSuccessAction
} from '@shared/widgets/store/actions/alerts.action';

export const initialState = null;

const featureReducer = createReducer(
  initialState,
  on(createAlertSuccessAction, () => 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.CREATED'), 
  on(deleteAlertSuccessAction, () => 'GENERAL_WIDGET_MODULE.ALERTS.DELETE.TITLE'),
  on(closeDeleteToastAction, () => initialState)
);

export const showAlertToastReducer = (state: string, action: Action): string => {
  return featureReducer(state, action);
};
